module.exports = __webpack_public_path__ + "static/media/patrol-hero.c5cef5fb.jpg";